import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useLanguagePopUpContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: languagePopUpContentJson {
        card {
          caption
          headline
          stay
          stay_language_code
          switch
          switch_language_code
        }
      }
      de: deLanguagePopUpContentJson {
        card {
          caption
          headline
          stay
          stay_language_code
          switch
          switch_language_code
        }
      }
    }
  `);

  return data[locale];
};
